import { Input, OnDestroy, Component, Output, EventEmitter } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UserService } from '../services';

@Component({
    selector: 'topic-summary-grid',
    styles: [`
        topic-summary {
            padding: 8px;
        }
        .scrollPanel {
            overflow-y: auto;
            height: calc(100vh - 65px);
        }

        .shortScrollPanel {
            overflow-y: auto;
            height: calc(100vh - 180px);
        }
    `],
    template: `
        <div *ngIf="!topics" fxLayout="column" fxLayoutAlign="center center" style="height:100%">
            <spinner></spinner>
        </div>
        <div *ngIf="topics && !topics.length && emptyMessage" fxLayout="column" fxLayoutAlign="center center" style="height:100%">
            <h4>{{emptyMessage}}</h4>
        </div>
        <div [class]="currentUser ? 'shortScrollPanel' : 'scrollPanel'"
             [style]="containerStyle"
             infiniteScroll 
             [infiniteScrollThrottle]="300"
             [infiniteScrollDistance]="1"
             [scrollWindow]="false"
             (scrolled)="nextPage.emit()">
        <mat-grid-list [cols]="columnCount" *ngIf="topics && topics.length" rowHeight="160px">
            <mat-grid-tile *ngFor="let topic of topics" fxLayoutAlign="center center">
                <topic-summary style="width: 95%" [topic]="topic"  [showTopicLink]="true" [linkPath]="linkPath"></topic-summary>    
            </mat-grid-tile>
        </mat-grid-list>
        </div>
    `
})
export class TopicSummaryGridComponent implements OnDestroy {
    private cleanupTime = new Subject<void>();    
    @Input() containerStyle: string;
    @Input() topics;
    @Input() linkPath = './';
    @Input() emptyMessage: string;
    @Output() nextPage = new EventEmitter<void>();
    columnCount: number;

    constructor(media: MediaObserver, public userService: UserService) {
        const count = () => this.columnCount = media.isActive('xs') || media.isActive('sm') ? 1 : (media.isActive('md') ? 2 : 3);
        media.media$.pipe(takeUntil(this.cleanupTime)).subscribe(() => count());
        count();
    }

    get currentUser(): any {
        return this.userService.getCurrentUser();
    }

    ngOnDestroy(): void {
        this.cleanupTime.next();
        this.cleanupTime.complete();
    }
}